import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import { CommonModal } from "./CommonModal";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import * as theme from "../theme";
import {
  getArrayOfProspectsId,
  getClientDetailsUsingProspectId,
  getGettingMyQuotes,
  getGettingMyQuotesSuccess,
  getMyQuotes,
  getMyQuotesCached,
  getStatus,
  getBrokers,
  getVertical,
  getRowDetailsFromProspectId,
  getFilteredProspectsIdArray,
  searchProspects,
  getSearchedProspectsArray,
  getGettingMyQuotesFailed,
  archiveProspect,
  getArchiveStatus,
} from "../store/myquotes";
import { getBrokerInformation } from "../store/broker";
import Loader3Orange from "../general/Loader3Orange";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
  storeProspectid,
} from "../store/quotes";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import { PossibleClientDetailsStatus } from "../store/helperfuncs";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import {
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-dropdown-select";
import WhiteTextField from "../general/TextFieldCustomized";
import ActionButton from "../general/ActionButton";
import { capitalizeFirstLetter } from "../utils/utils";
import externalTranslations from "../utils/translations";
import "moment/locale/fr"; // Import French locale data
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";
const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

// Status translations - shared across components
const statusTranslations = {
  New: {
    fr: "Nouveau",
    en: "New"
  },
  "App In Progress": {
    fr: "En cours",
    en: "App In Progress"
  },
  "Close - Incomplete Info": {
    fr: "Fermé - Informations incomplètes",
    en: "Close - Incomplete Info"
  },
  "App Completed": {
    fr: "Application terminée",
    en: "App Completed"
  },
  "In Market": {
    fr: "Sur le marché",
    en: "In Market"
  },
  "Close - No Insurer": {
    fr: "Fermé - Aucun assureur",
    en: "Close - No Insurer",
  },
  Quoted: {
    fr: "Devis fourni",
    en: "Quoted",
  },
  "Not Interested": {
    fr: "Pas intéressé",
    en: "Not Interested"
  },
  Sold: {
    fr: "Vendu",
    en: "Sold"
  },
  "Send to Market": {
    fr: "Envoyer au marché",
    en: "Send to Market"
  },
  "Continued Quote": {
    fr: "Suite du devis",
    en: "Continued Quote"
  },
  "Client Presentation": {
    fr: "Présentation client",
    en: "Client Presentation"
  },
  "Quote received": {
    fr: "Devis reçu",
    en: "Quote received"
  },
  "Client adjustments": {
    fr: "Ajustements clients",
    en: "Client adjustments"
  },
  "Added Insurer": {
    fr: "Assureur ajouté",
    en: "Added Insurer"
  },
  "Quoted to client": {
    fr: "Devis envoyé au client",
    en: "Quoted to client"
  },
  "Quote(s) received": {
    fr: "Devis reçu(s)",
    en: "Quote(s) received"
  },
  "Terms received": {
    fr: "Conditions reçues",
    en: "Terms received"
  },
  "Under Review": {
    fr: "En révision",
    en: "Under Review"
  },
  Renewed: {
    fr: "Renouvelé",
    en: "Renewed"
  },
  "Lost - No Insurer": {
    fr: "Perdu - Aucun assureur",
    en: "Lost - No Insurer"
  },
  "Lost - Not Interested": {
    fr: "Perdu - Pas intéressé",
    en: "Lost - Not Interested"
  },
  "Lost - Incomplete Info": {
    fr: "Perdu - Information incomplète",
    en: "Lost - Incomplete Info"
  },
  "Lost - Bad Opportunity": {
    fr: "Perdu - Mauvaise opportunité",
    en: "Lost - Bad Opportunity"
  },
  "Resolicit at Renewal": {
    fr: "Solliciter au renouvellement",
    en: "Resolicit at Renewal"
  },
  "App with Client": {
    fr: "Demande avec client",
    en: "App with Client"
  },
  "Renewal App with Client": {
    fr: "Demande de renouvellement avec client",
    en: "Renewal App with Client"
  },
  "Contact attempted": {
    fr: "Tentative de contact",
    en: "Contact attempted"
  },
  "Call back": {
    fr: "Rappeler",
    en: "Call back"
  },
  "Client updated app": {
    fr: "Client a mis à jour la demande",
    en: "Client updated app"
  },
  Information: {
    fr: "Information",
    en: "Information"
  },
  "Renewal app in progress": {
    fr: "Demande de renouvellement en cours",
    en: "Renewal app in progress"
  },
  "Sent to Market": {
    fr: "Envoyer au marché",
    en: "Sent to Market"
  },
  "Insurer declined": {
    fr: "Assureur refusé",
    en: "Insurer declined"
  },
  "Quote Confirmed": {
    fr: "Devis confirmé",
    en: "Quote Confirmed"
  },
  Lapse: {
    fr: "Expiré",
    en: "Lapse"
  },
};

function translateStatus(status, langPref) {
  if (statusTranslations[status] && statusTranslations[status][langPref]) {
    return statusTranslations[status][langPref];
  } else {
    // Handle cases where the status or language preference is not found
    console.warn(
      `No translation found for status "${status}" and language "${langPref}". Returning original status.`
    );
    return status; // Or you could return a default translation
  }
}

const MyQuotes = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.myquotes })
    );
  }, [dispatch]);
  const [query, setQuery] = useState("");
  const [brokerFilter, setBrokerFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [verticalFilter, setVerticalFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [showBoardView, setBoardViewVisbility] = useState(false);
  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        <TwoPanesPanel
          myquotesscreen={true}
          myquotesleftpane={
            showBoardView ? (
              <BoardView
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
              />
            ) : (
              <MyQuotesLeftPane
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
                setStatusFilter={setStatusFilter}
              />
            )
          }
          myquotesrightpane={
            <MyQuotesRightPane
              setQuery={setQuery}
              query={query}
              startDateFilter={startDateFilter}
              endDateFilter={endDateFilter}
              setBrokerFilter={setBrokerFilter}
              setStatusFilter={setStatusFilter}
              statusFilter={statusFilter}
              setVerticalFilter={setVerticalFilter}
              setStartDateFilter={setStartDateFilter}
              setEndDateFilter={setEndDateFilter}
            />
          }
          overflowY={"hidden"}
        ></TwoPanesPanel>
      </MainPane>
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const MyQuotesLeftPane = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const MyQuotesCached = useSelector(getMyQuotesCached);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prospectArchiveStatus = useSelector(getArchiveStatus);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";
  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      backToApplication={
        <BackToApplication
          text={externalTranslations[languagepreference]?.backToHomePage}
          onClick={() => {
            //navigate(`/`);
            document.location.href = `/`;
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={externalTranslations[languagepreference]?.prospectsHeader}
            heading2={
              externalTranslations[languagepreference]?.prospectsSubHeader
            }
          ></TwoHeading>
          {MyQuotesCached ? (
            <OrangeButton
              onClick={() => dispatch(getMyQuotes({ preventCache: true }))}
              width="1.5vw"
              fontSize="2vh"
              text="Regenerate all Prospects"
            />
          ) : null}
          {/* <OrangeButton
            onClick={() => props.setBoardViewVisbility(true)}
            width="12.5vw"
            fontSize="2vh"
            text="Board View"
          /> */}
        </div>
      }
      tableHeaderSection={<MyQuotesTableHeader></MyQuotesTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <MyQuotesRowsSection heightDivison={heightDivison}>
          <MyQuotesEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
            setStatusFilter={props.setStatusFilter}
          ></MyQuotesEachRow>
        </MyQuotesRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const SomethingFailedGettingMyQuotes = () => {
  return <div>Something failed getting my quotes, please contact admin.</div>;
};

const MyQuotesRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyQuotesInitialized = useSelector(getGettingMyQuotes);
  const gettingMyQuotesSucceed = useSelector(getGettingMyQuotesSuccess);
  const gettingMyQuotesFailed = useSelector(getGettingMyQuotesFailed);
  useEffect(() => {
    dispatch(getMyQuotes(null));
  }, [dispatch]);
  return (
    <>
      {gettingMyQuotesInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyQuotesSucceed ? (
        props.children
      ) : (
        gettingMyQuotesFailed && (
          <SomethingFailedGettingMyQuotes></SomethingFailedGettingMyQuotes>
        )
      )}
    </>
  );
};

const MyQuotesEachRow = (props) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const prospectfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects
    )
  );
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();
  const itemsPerPage = 10;
  const maxPages = 10;

  // Logic for displaying page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(prospectfilteredorder.length / itemsPerPage);
  const arrPageLimiter = [totalPages, maxPages];
  for (let i = 1; i <= Math.min(...arrPageLimiter); i++) {
    pageNumbers.push(i);
  }

  useEffect(()=> {
    const queryObject = {};
    for (const [key, value] of searchParams.entries()) {
      queryObject[key] = value;
    }
    if(queryObject.status){
      let status = queryObject.status;
      let statusMap = {
        'market': 'In Market',
        'quoted':'Quoted',
        'inprogress':'App In Progress',
        'clientadj':'Client adjustments',
      }
      if(statusMap[status]){
        props.setStatusFilter(statusMap[status])
      }  
    }

  }, [])

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {prospectfilteredorder.map((prospectid, x) =>
          x >= (currentPage - 1) * itemsPerPage &&
          x < currentPage * itemsPerPage ? (
            <ProspectRow key={x} prospectid={prospectid}></ProspectRow>
          ) : null
        )}
      </div>
      <div>
        <ul className="pagination justify-content-center">
          {pageNumbers.map((x) => (
            <li
              key={x}
              className={x === currentPage ? "page-item active" : "page-item"}
            >
              <a
                className="page-link"
                onClick={() => {
                  setCurrentPage(x);
                }}
              >
                {x}
              </a>
            </li>
          ))}
          {totalPages > maxPages ? (
            <li
              key={totalPages}
              className={
                totalPages === currentPage ? "page-item active" : "page-item"
              }
            >
              <input
                className="page-link"
                style={{ width: "80px" }}
                placeholder={".." + totalPages}
                type="number"
                min="1"
                max={totalPages}
                onChange={(event) => {
                  setCurrentPage(event.target.value);
                }}
              ></input>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

const ProspectRow = ({ prospectid }) => {
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );

  //console.log("looseing", prospectDetails);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const broker = useSelector(getBrokerInformation);
  let isAdmin = broker.isadmin;
  var [openModal, setopenModal] = useState(false);
  const useClasses = makeStyles((theme) => ({
    icon: {
      "&:hover": {
        color: "red",
      },
    },
  }));
  const classes = useClasses();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.brokername}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Business_name}
        ></ClientDetailsGeneral>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.vertical[languagepreference]}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Name}
        ></ClientDetailsGeneral>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        <a
          href={
            "tel:" +
            prospectDetails.clientdetails[Client_Contact]?.replace(
              /[^0-9]+/g,
              ""
            )
          }
        >
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Contact}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        <a href={"mailto:" + prospectDetails.clientdetails[Client_Email]}>
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Email}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        <NormalText
          text={translateStatus(
            capitalizeFirstLetter(prospectDetails.status),
            languagepreference
          )}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        {/* <FormateDate millliseconds={prospectDetails.lastupdated}></FormateDate> */}
        <FormattedDate
          milliseconds={prospectDetails.lastupdated}
          languagepreference={languagepreference}
        ></FormattedDate>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
          justifyContent: isAdmin ? "space-evenly" : "center",
        }}
      >
        <OrangeButton
          text={externalTranslations[languagepreference]?.review}
          color={theme.COLORS.primary_navyblue}
          width="10vmin"
          onClick={() => {
            dispatch(storeProspectid(prospectid));
            //navigate(`/prospect?id=${prospectid}`);
            document.location.href = `/prospect?id=${prospectid}`;
          }}
        ></OrangeButton>
        <DeleteOutlineOutlinedIcon
          className={classes.icon}
          style={{ display: isAdmin ? null : "none", cursor: "pointer" }}
          onClick={() => {
            //dispatch(archiveProspect({prospectid}));
            setopenModal(true);
          }}
        />
      </div>
      <CommonModal
        modalHeight={"25vh"}
        modalWidth={"20vw"}
        openModalBool={openModal}
        closeModal={() => setopenModal(false)}
        handleSbmtBtn={() => {
          dispatch(archiveProspect({ prospectid }));
          setopenModal(false);
        }}
        buttontxt={"Yes"}
        heading={"Delete Confirmation"}
      >
        <p>
          Are you sure you want to delete{" "}
          {prospectDetails["CLIENT_BUSINESS_NAME"] || "this"} prospect?
        </p>
      </CommonModal>
    </div>
  );
};
const FormattedDate = ({ milliseconds, languagepreference }) => {
  let date = new Date(milliseconds);
  let dateFormatted = moment(date)
    .locale(languagepreference)
    .format("DD MMM YYYY");

  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};
const FormateDate = ({ millliseconds }) => {
  let date = new Date(millliseconds);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY");
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};
const ClientDetailsGeneral = ({
  prospectDetails,
  ClientDetailPartName,
  textColor,
  fontSize,
}) => {
  const [show, setShow] = useState(false);
  if (!textColor) textColor = "grey";
  if (!fontSize) fontSize = 15;
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(timeout);
  });

  return (
    <>
      {show ? (
        <NormalText
          text={prospectDetails[ClientDetailPartName]}
          fontWeight={"normal"}
          fontSize={fontSize}
          color={textColor}
        ></NormalText>
      ) : (
        ""
      )}
    </>
  );
};

const MyQuotesTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const translations = {
    // **New Translations for Column Headings**
    en: {
      columnHeadingsQuotes: {
        first: "Broker",
        second: "Client",
        third: "Vertical",
        fourth: "Contact Name",
        fifth: "Contact Number",
        sixth: "Contact Email",
        seventh: "Status",
        eighth: "Last Update",
        ninth: "Review Details",
      },
    },
    fr: {
      columnHeadingsQuotes: {
        first: "Courtier",
        second: "Client",
        third: "Secteur d'activités​",
        fourth: "Nom du contact",
        fifth: "Numéro de Contact",
        sixth: "Courriel du contact",
        seventh: "Statut",
        eighth: "Dernière Mise à Jour",
        ninth: "Réviser les détails",
      },
    },
  };
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";
  const columnHeadingsQuotes = {
    first:
      translations[languagepreference]?.columnHeadingsQuotes.first ||
      translations["en"].columnHeadingsQuotes.first,
    second:
      translations[languagepreference]?.columnHeadingsQuotes.second ||
      translations["en"].columnHeadingsQuotes.second,
    third:
      translations[languagepreference]?.columnHeadingsQuotes.third ||
      translations["en"].columnHeadingsQuotes.third,
    fourth:
      translations[languagepreference]?.columnHeadingsQuotes.fourth ||
      translations["en"].columnHeadingsQuotes.fourth,
    fifth:
      translations[languagepreference]?.columnHeadingsQuotes.fifth ||
      translations["en"].columnHeadingsQuotes.fifth,
    sixth:
      translations[languagepreference]?.columnHeadingsQuotes.sixth ||
      translations["en"].columnHeadingsQuotes.sixth,
    seventh:
      translations[languagepreference]?.columnHeadingsQuotes.seventh ||
      translations["en"].columnHeadingsQuotes.seventh,
    eighth:
      translations[languagepreference]?.columnHeadingsQuotes.eighth ||
      translations["en"].columnHeadingsQuotes.eighth,
    ninth:
      translations[languagepreference]?.columnHeadingsQuotes.ninth ||
      translations["en"].columnHeadingsQuotes.ninth,
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};
//#endregion

const BoardView = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const MyQuotesCached = useSelector(getMyQuotesCached);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const navigate = useNavigate();
  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      backToApplication={
        <BackToApplication
          text={externalTranslations[languagepreference]?.backToHomePage}
          onClick={() => {
            // navigate(`/`);
            document.location.href = `/`;
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={"Your Prospects"}
            heading2={
              "Filter below, or scroll through all your client activity"
            }
          ></TwoHeading>
          <OrangeButton
            onClick={() => props.setBoardViewVisbility(false)}
            width="12.5vw"
            fontSize="2vh"
            text="Details View"
          />
        </div>
      }
      tableHeaderSection={<BoardTableHeader></BoardTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <BoardRowsSection heightDivison={heightDivison}>
          <BoardEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
          ></BoardEachRow>
        </BoardRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const BoardTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyQuotesTable;

  const columnHeadingsQuotes = {
    first: "New",
    second: "App In Progress",
    third: "App Completed",
    fourth: "In Market",
    fifth: "Quoted",
    sixth: "Sold",
    seventh: "Close - Incomplete Info",
    eighth: "Close - No Insurer",
    ninth: "Not Interested",
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};

const BoardRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyQuotesInitialized = useSelector(getGettingMyQuotes);
  const gettingMyQuotesSucceed = useSelector(getGettingMyQuotesSuccess);
  const gettingMyQuotesFailed = useSelector(getGettingMyQuotesFailed);

  useEffect(() => {
    dispatch(getMyQuotes(null));
  }, [dispatch]);

  return (
    <>
      {gettingMyQuotesInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyQuotesSucceed ? (
        props.children
      ) : (
        gettingMyQuotesFailed && (
          <SomethingFailedGettingMyQuotes></SomethingFailedGettingMyQuotes>
        )
      )}
    </>
  );
};

const BoardEachRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const prospectfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects
    )
  );
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();

  const classes = useStyles();

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {prospectfilteredorder.slice(0, 100).map((prospectid, index) => (
          <BoardRow key={index} prospectid={prospectid}></BoardRow>
        ))}
      </div>
    </div>
  );
};

const BoardRow = ({ prospectid }) => {
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const languagepreference = useSelector(getLanguageCode);

  const ColoumnWidth = theme.columnWidthMyQuotesTable;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (
      prospectDetails.clientdetails === PossibleClientDetailsStatus.notstarted
    )
      dispatch(getClientDetailsUsingProspectId({ prospectid }));
  }, [searchedProspects]);
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "new" || prospectDetails.status == "New" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App In Progress" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App Completed" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "In market" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Quoted" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Sold" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - Incomplete Info" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - No Insurer" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/prospect?id=${prospectid}`);
              document.location.href = `/prospect?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        {prospectDetails.status == "Not Interested" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              document.location.href = `/prospect?id=${prospectid}`;
              //navigate(`/prospect?id=${prospectid}`);
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

//#region Right Pane
const MyQuotesRightPane = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const useStyles = makeStyles({
    datePicker: {
      "& .MuiInputBase-root": {
        padding: 0,
        backgroundColor: "#ffffff",
        width: "12.5vw",
        "& .MuiButtonBase-root": {
          padding: 0,
          paddingRight: 10,
          backgroundColor: "#ffffff",
        },
        "& .MuiInputBase-input": {
          padding: 10,
          paddingLeft: 10,
          backgroundColor: "#ffffff",
        },
      },
    },
  });
  const classes = useStyles();
  const brokers = useSelector(getBrokers);
  const statuses = useSelector(getStatus);
  const verticals = useSelector(getVertical);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const locale = languagepreference === "fr" ? frLocale : enLocale;
  const options = [
    { value: "week", label: externalTranslations[languagepreference]?.dashboard?.thisWeek || "This Week" },
    { value: "month", label: externalTranslations[languagepreference]?.dashboard?.thisMonth || "This Month" },
    { value: "year", label: externalTranslations[languagepreference]?.dashboard?.thisYear || "This Year" },
    { value: "custom", label: externalTranslations[languagepreference]?.dashboard?.custom || "Custom" },
  ];
  const [statusDisplayValue, setStatusDisplayValue] = useState([]);

  useEffect(() => {
    if (props.statusFilter) {
      const translatedLabel = translateStatus(props.statusFilter, languagepreference);
      console.log('Status filter display update:', {
        rawValue: props.statusFilter,
        translatedLabel,
        language: languagepreference
      });
      setStatusDisplayValue([{
        label: translatedLabel,
        value: props.statusFilter
      }]);
    } else {
      setStatusDisplayValue([]);
    }
  }, [props.statusFilter, languagepreference]);

  const boptions = [];
  for (const b of brokers) {
    boptions.push({ value: b, label: b });
  }
  const soptions = [];
  for (const b of statuses) {
    // Try translating the raw value directly first
    let translatedLabel = translateStatus(b, languagepreference);

    // If no translation found for raw value, try with transformation
    if (translatedLabel === b) {
      const displayLabel = b.charAt(0).toUpperCase() + b.slice(1).replace(/([A-Z])/g, ' $1').trim();
      translatedLabel = translateStatus(displayLabel, languagepreference);
    }

    soptions.push({ value: b, label: translatedLabel });
  }
  const voptions = [];
  const uniquevs = [];
  console.log("verticals: ", verticals)
  for (const b of verticals) {
    if (!uniquevs.includes(b[languagepreference]) && b[languagepreference] ) {
      uniquevs.push(b[languagepreference]);
      voptions.push({
        value: b[languagepreference],
        label: b[languagepreference],
      });
    }
  }

  const [isCustomDate, setIsCustomDate] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: "3vw",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "GibsonLight",
        color: theme.COLORS.tertiary_lightbackground,
      }}
    >
      <div>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 26,
            color: theme.COLORS.primary_navyblue,
          }}
        >
          {externalTranslations[languagepreference]?.filters.header ||
            externalTranslations["en"].filters.header}
        </Typography>
      </div>
      {loading ? (
        <div
          style={{
            width: "100%",
          }}
        >
          <Loader3Orange />
        </div>
      ) : (
        <div />
      )}
      <FormControl sx={{ m: 0, minWidth: 260 }} style={{ marginTop: "20px" }}>
        <div>
          <input
            id="txtQuery"
            placeholder={
              externalTranslations[languagepreference]?.form
                .searchForClientPlaceholder ||
              externalTranslations["en"].form.searchForClientPlaceholder
            }
            style={{
              backgroundColor: "#ffffff",
              width: "80%",
              display: "inline-flex",
              borderStartEndRadius: "0px",
              borderEndEndRadius: "0px",
            }}
            className="form-control"
            onChange={(event) => {
              props.setQuery(event.target.value);
            }}
          />
          <div
            style={{
              display: "inline-flex",
              paddingLeft: "3.5%",
              paddingTop: "6px",
              paddingRight: "3.5%",
              backgroundColor: theme.COLORS.secondary_orange,
              borderStartEndRadius: "5px",
              borderEndEndRadius: "5px",
            }}
          >
            <label
              onClick={(event) => {
                setLoading(true);
                dispatch(searchProspects(props.query)).then(() =>
                  setLoading(false)
                );
              }}
            >
              🔍
            </label>
          </div>
        </div>
      </FormControl>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {externalTranslations[languagepreference]?.filters.dateHeader ||
            externalTranslations["en"].filters.dateHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={options}
            placeholder={externalTranslations[languagepreference].select}
            // placeholder={
            //   externalTranslations[languagepreference]?.filters
            //     .selectPaymentMethodPlaceholder ||
            //   externalTranslations["en"].filters.selectPaymentMethodPlaceholder
            // }
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              color:"black"
            }}
            onChange={(e) => {
              var today = new Date();
              var pastWeek = new Date();
              var pastMonth = new Date();
              var pastYear = new Date();
              pastWeek.setDate(pastWeek.getDate() - 7);
              pastMonth.setDate(pastMonth.getDate() - 30);
              pastYear.setDate(pastYear.getDate() - 365);
              if (e.length === 0) {
                props.setStartDateFilter(null);
                props.setEndDateFilter(null);
                setIsCustomDate(false);
              } else if (e[0].value === "week") {
                props.setStartDateFilter(pastWeek);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "month") {
                props.setStartDateFilter(pastMonth);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "year") {
                props.setStartDateFilter(pastYear);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "custom") {
                setIsCustomDate(true);
              }
            }}
          />
        </FormControl>
        <div style={{ width: "250px" }}>
          {isCustomDate ? (
            <div>
              <div>
                <p style={{ margin: "0px", marginTop: "5px" }}>
                  {externalTranslations[languagepreference]?.form.fromLabel ||
                    "From"}
                </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <KeyboardDatePicker
                    placeholder={
                      languagepreference === "fr" ? "jj/mm/aaaa" : "mm/dd/yyyy"
                    }
                    cancelLabel={
                      externalTranslations[languagepreference].cancel
                    }
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.startDateFilter}
                    format="MMM dd, yyyy"
                    onChange={(e) => {
                      props.setStartDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div>
                <p style={{ margin: "0px" }}>
                  {externalTranslations[languagepreference]?.form.toLabel ||
                    "To"}
                </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.endDateFilter}
                    minDate={props.startDateFilter}
                    format="MMM dd, yyyy"
                    onChange={(e) => {
                      props.setEndDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {externalTranslations[languagepreference]?.filters.statusHeader ||
            externalTranslations["en"].filters.statusHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={externalTranslations[languagepreference].select}
            options={soptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              color:"black"
            }}
            values={statusDisplayValue}
            onChange={(e) => {
              if (e.length === 0) {
                props.setStatusFilter("");
              } else {
                props.setStatusFilter(e[0].value);
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {externalTranslations[languagepreference]?.filters.verticalHeader ||
            externalTranslations["en"].filters.verticalHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={externalTranslations[languagepreference].select}
            options={voptions}  //voptions
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              color:"black"
            }}
            onChange={(e) => {
              if (e.length) {
                props.setVerticalFilter(e[0].value);
              } else {
                props.setVerticalFilter("");
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {externalTranslations[languagepreference]?.filters.brokerHeader ||
            externalTranslations["en"].filters.brokerHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={externalTranslations[languagepreference].select}
            options={boptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
              color:"black"
            }}
            onChange={(e) => {
              if (e.length === 0) {
                props.setBrokerFilter("");
              } else {
                props.setBrokerFilter(e[0].value);
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <OrangeButton
          text={
            externalTranslations[languagepreference]?.filters
              .clearFiltersButton || "Clear Filters"
          }
          width="12.5vw"
          onClick={(e) => {
            window.location.reload(false);
          }}
        />
      </div>
    </div>
  );
};

export default MyQuotes;
